// extracted by mini-css-extract-plugin
export default {"container":"Ja8eo","body":"nspnl","social-actions":"eaR2W","copy-url-action":"jc1QD","copy-url":"vzpbe","facebook-container":"GKHED"};